import { Navigate, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/firebase";
import { JSX } from "react";

const guestOnlyUID = "WxkRybjDhWTKWGfWUs4zgYHhyrW2";

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const [user, loading] = useAuthState(auth);
  const location = useLocation();

  if (loading) return <p>Cargando...</p>;

  const loginTime = localStorage.getItem("loginTime");
  const now = Date.now();
  const sessionDurationLimit = 24 * 60 * 60 * 1000;
  const sessionExpired =
    loginTime && now - parseInt(loginTime) > sessionDurationLimit;

  if (sessionExpired) {
    auth.signOut();
    localStorage.removeItem("loginTime");
  }

  const shouldRedirect = !user || sessionExpired;

  if (shouldRedirect) {
    return (
      <Navigate to="/admin/login" state={{ from: location.pathname }} replace />
    );
  }

  if (user?.uid === guestOnlyUID && location.pathname !== "/admin/guest-list") {
    return <Navigate to="/admin/guest-list" replace />;
  }

  return children;
};
